import { render, staticRenderFns } from "./study_model_proposal.vue?vue&type=template&id=69b063ce&scoped=true&"
import script from "./study_model_proposal.vue?vue&type=script&lang=js&"
export * from "./study_model_proposal.vue?vue&type=script&lang=js&"
import style0 from "./study_model_proposal.vue?vue&type=style&index=0&id=69b063ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b063ce",
  null
  
)

export default component.exports